const PitchStrikeZoneLocation = {
    'TopLeft': { key: 'TL', name: 'Top Left'},
    'TopCenter': { key: 'TC', name: 'Top Center'},
    'TopRight': { key: 'TR', name: 'Top Right'},

    'MiddleLeft': { key: 'ML', name: 'Middle Left'},
    'MiddleCenter': { key: 'MC', name: 'Middle Center'},
    'MiddleRight': { key: 'MR', name: 'Middle Right'},

    'BottomLeft': { key: 'BL', name: 'Bottom Left'},
    'BottomCenter': { key: 'BC', name: 'Bottom Center'},
    'BottomRight': { key: 'BR', name: 'Bottom Right'},

    'TopBar': { key: 'TB', name: 'Top Bar'},
    'BottomBar': { key: 'BB', name: 'Bottom Bar'},
    'LeftBar': { key: 'LB', name: 'Left Bar'},
    'RightBar': { key: 'RB', name: 'Right Bar'},

    'Undefined': { key: 'UI', name: 'Undefined'}
};

export default PitchStrikeZoneLocation;